import _ from 'lodash'
import { defaultState } from '@/store/index'
import pages from '@/store/pages'

const states = [
  { name: 'SiteRole', module: pages.siteRole },
  { name: 'PermissionRole', module: pages.permissionRole },
  { name: 'Upload', module: pages.upload },
  { name: 'Download', module: pages.download },
  { name: 'Batch', module: pages.batch },
  { name: 'Customer', module: pages.customer },
  { name: 'CustomerRank', module: pages.customerRank },
  { name: 'Log', module: pages.log },
  { name: 'Order', module: pages.order },
  { name: 'Point', module: pages.point },
  { name: 'PointSetting', module: pages.pointSetting },
  { name: 'Account', module: pages.account },
  { name: 'Product', module: pages.product },
  { name: 'ProductDetail', module: pages.productDetail },
  { name: 'StockAlert', module: pages.stockAlert },
  { name: 'EcStock', module: pages.ecStock },
  { name: 'MasterColor', module: pages.masterColor },
  { name: 'MasterColorGroup', module: pages.masterColorGroup },
  { name: 'MasterSize', module: pages.masterSize },
  { name: 'MasterSizeGroup', module: pages.masterSizeGroup },
  { name: 'OrderQuantity', module: pages.orderQuantity },
  { name: 'MasterLogisticsCalendar', module: pages.masterLogisticsCalendar },
  { name: 'MailTemplate', module: pages.mailTemplate },
  { name: 'StockAdjustment', module: pages.stockAdjustment },
  { name: 'stockMove', module: pages.stockMove },
  { name: 'destination', module: pages.destination },
  { name: 'PendingProduct', module: pages.pendingProduct },
  { name: 'Payment', module: pages.payment },
  { name: 'PaymentConvenience', module: pages.paymentConvenience },
  { name: 'PaymentCarrier', module: pages.paymentCarrier },
  { name: 'PaymentId', module: pages.paymentId },
  { name: 'Sales', module: pages.sales },
  { name: 'SalesDigital', module: pages.salesDigital },
  { name: 'SalesProductPhysical', module: pages.salesProductPhysical },
  { name: 'SalesProductDigital', module: pages.salesProductDigital },
  { name: 'SalesYell', module: pages.salesYell }

]

export default {
  /**
   * 指定した key に value をセットします。
   * @param {Object} state store state
   * @param {Object} payload
   */
  set (state, { type, states }) {
    Object.keys(states).forEach(key => {
      // const spKey = key.split('/');
      // const count = spKey.length - 1;
      // if (count === 1) {
      //   state[spKey[0]][spKey[1]] = states[key];
      // } else if (count === 0) {
      //   state[key] = states[key];
      // }
      // TODO keyが階層になっている場合、セットできていなかったので_.setを使うようにした
      // TODO _.setのkeyの区切り文字は'.'なので'/'を置換している
      // TODO 呼び出し元で'.'区切りのkeyを渡すようにしたい
      _.set(state, _.replace(key, /\//g, '.'), states[key])
    })
  },
  /**
   * 指定した key に value をセットします。(階層データ)
   * @param {Object} state store state
   * @param {Object} payload
   */
  setValue (state, { type, states: { target, key, value } }) {
    target[key] = value
  },
  /**
   * searchConditions.[property].value を更新する.
   * @param {*} state
   * @param {*} payload
   */
  updateSearchConditionsValue (state, { storePath, path, value }) {
    state[storePath].searchConditions[path].value = value
    if (state[storePath].searchConditions[path].filter) {
      // filter が定義されている場合、メソッドを呼び出す.
      state[storePath].searchConditions[path].filter(state[storePath])
    }
  },
  /**
   * state の値を初期化する.
   * @param {*} state
   */
  initializeState (state) {
    Object.assign(state, defaultState())
    for (let i = 0; i < states.length; i++) {
      if (state[states[i].name] != null && states[i].module.getDefaultState) {
        Object.assign(state[states[i].name], states[i].module.getDefaultState())
      }
    }
  }
}
